export default "__VITE_ASSET__75813f04__"